export default __webpack_public_path__ + "static/media/bannerContadores2.6bc30cd6.jpg";